import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: 
    () => import('./comissao-listar/comissao-listar.module').then(m => m.ComissaoListarModule) },
  ])],
  exports: [RouterModule]
})
export class ComissaoRoutingModule { }
